import { Scene } from "./types";

// Auto-registers every scene in this folder (same require.context idiom as
// tutorials/index.ts). To add a scene: drop a `<id>.ts` file here that
// default-exports a Scene whose `id` matches the file name.
const ctx = (require as any).context("./", false, /^\.\/(?!types$|index$)[^/]+\.ts$/);

export const ALL_SCENES: Scene[] = ctx
  .keys()
  .map((key: string) => {
    const mod = ctx(key);
    return (mod && (mod.default as Scene)) || null;
  })
  .filter((s: Scene | null): s is Scene => !!s && Array.isArray(s.steps));

export const getSceneById = (id: string): Scene | undefined => ALL_SCENES.find((s) => s.id === id);
